var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"tr-values vs-table--tr tr-table-state-null"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }